import { render, staticRenderFns } from "./MenuPlugCircleCheckFilled.vue?vue&type=template&id=fb11a3f8"
var script = {}


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports